import * as z from "zod";

export const getSkioIntegration = {
  name: "getSkioIntegration" as const,
  input: z.null(),
  // The API key is write-only: report only whether one is stored.
  output: z.object({ exists: z.boolean(), hasApiKey: z.boolean().optional() }),
};
